// RigSentinel Calc — Daily Drilling Report draft storage.
// New namespaced key, isolated from calculator save bucket. Local-only.
//
// Phase A parity fix: write paths (save/delete) require RigSentinel Pro,
// matching every other report type's storage module (see
// lib/reports/storage.js's _requireProForWrite). Read paths stay public so
// Preview users can still browse pre-existing drafts.
import { getCachedEntitlement } from "../entitlement";
import { isProActive, FeatureLockedError } from "../featureAccess";
import { scoped } from "../accountScope";

const DDR_KEY = "rsc.ddr.drafts.v1";

const safeParse = (s, fallback) => {
  try { return JSON.parse(s) ?? fallback; } catch { return fallback; }
};

function _requireProForWrite(action) {
  if (!isProActive(getCachedEntitlement())) {
    throw new FeatureLockedError(
      `${action} is available with RigSentinel Pro.`,
      { feature: "ddr.storage.write" },
    );
  }
}

export function getDdrDrafts() {
  return safeParse(scoped.getItem(DDR_KEY), []);
}

export function getDdrDraft(id) {
  return getDdrDrafts().find((d) => d.id === id) || null;
}

export function saveDdrDraft(state) {
  _requireProForWrite("Saving a Daily Drilling Report draft");
  const list = getDdrDrafts();
  const now = new Date().toISOString();
  let item;
  if (state.id) {
    item = { ...state, updatedAt: now };
    const idx = list.findIndex((d) => d.id === state.id);
    if (idx >= 0) list[idx] = item;
    else list.unshift(item);
  } else {
    item = {
      ...state,
      id: `ddr-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
      createdAt: now,
      updatedAt: now,
    };
    list.unshift(item);
  }
  scoped.setItem(DDR_KEY, JSON.stringify(list.slice(0, 100)));
  return item;
}

export function deleteDdrDraft(id) {
  _requireProForWrite("Deleting a Daily Drilling Report draft");
  const list = getDdrDrafts().filter((d) => d.id !== id);
  scoped.setItem(DDR_KEY, JSON.stringify(list));
}
